import React from "react";

function LifemapLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsSvgjs="http://svgjs.dev/svgjs"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="290"
      height="290"
      viewBox="300 0 1000 290"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="1000"
        height="290"
        data-background-color="#abc4ff"
        transform="translate(-.606 -.386)"
        viewBox="0 0 396 115"
      >
        <svg
          width="395.52"
          height="114.694"
          transform="translate(.24 .153)"
          viewBox="0 0 395.52 114.694"
        >
          <svg width="395.52" height="114.694" viewBox="0 0 395.52 114.694">
            <svg width="395.52" height="114.694" viewBox="0 0 395.52 114.694">
              <svg width="395.52" height="114.694" viewBox="0 0 395.52 114.694">
                <g>
                  <svg
                    width="395.52"
                    height="114.694"
                    viewBox="0 0 395.52 114.694"
                  >
                    <svg
                      width="395.52"
                      height="114.694"
                      viewBox="0 0 395.52 114.694"
                    >
                      <svg
                        width="395.52"
                        height="114.694"
                        data-palette-color="#ff6d00"
                        viewBox="3.9 -38.8 165.69 48.05"
                      >
                        <path
                          fill="#ff6d00"
                          d="M12.45-3.4L11.8.5Q7.5.4 5.7-1.35 3.9-3.1 3.9-6.8V-38l4.65-.8v31.25q0 1.15.2 1.9t.65 1.2q.45.45 1.2.67.75.23 1.85.38zM22.3-26V0h-4.65v-26h4.65zm-2.35-4.7q-1.25 0-2.13-.83-.87-.82-.87-2.22 0-1.4.87-2.23.88-.82 2.13-.82t2.12.82q.88.83.88 2.23t-.88 2.22q-.87.83-2.12.83zm20.5-8.1q2.04 0 3.52.3t2.08.55l-.85 4q-.61-.3-1.71-.57-1.1-.28-2.69-.28-3.25 0-4.56 1.78-1.29 1.77-1.29 4.77V-26h10v3.9h-10V0h-4.66v-28.35q0-5 2.45-7.73 2.46-2.72 7.71-2.72zm7.69 25.85q0-3.45 1-6.03 1-2.57 2.65-4.27 1.65-1.7 3.8-2.55 2.15-.85 4.4-.85 5.25 0 8.05 3.27 2.8 3.28 2.8 9.98v.77q0 .48-.05.88h-17.8q.3 4.05 2.35 6.15 2.05 2.1 6.4 2.1 2.45 0 4.13-.43 1.67-.42 2.52-.82l.65 3.9q-.85.45-2.97.95-2.13.5-4.83.5-3.4 0-5.87-1.03-2.48-1.02-4.08-2.82-1.6-1.8-2.37-4.28-.78-2.47-.78-5.42zm4.95-2.55h12.9q.05-3.15-1.57-5.18-1.63-2.02-4.48-2.02-1.6 0-2.82.62-1.23.63-2.08 1.63-.85 1-1.32 2.3-.48 1.3-.63 2.65zM77.54 0v-25.25q1.6-.4 4.23-.85 2.62-.45 6.07-.45 2.5 0 4.2.67 1.7.68 2.85 1.98.35-.25 1.1-.7.75-.45 1.85-.88 1.1-.42 2.45-.75 1.35-.32 2.9-.32 3 0 4.9.87 1.9.88 2.97 2.48 1.08 1.6 1.46 3.8.37 2.2.37 4.8V0h-4.65v-13.6q0-2.3-.22-3.95-.23-1.65-.85-2.75-.63-1.1-1.7-1.63-1.08-.52-2.78-.52-2.35 0-3.87.62-1.53.63-2.08 1.13.4 1.3.6 2.85.2 1.55.2 3.25V0h-4.65v-13.6q0-2.3-.25-3.95-.25-1.65-.87-2.75-.63-1.1-1.7-1.63-1.08-.52-2.73-.52-.7 0-1.5.05t-1.52.12q-.73.08-1.33.18-.6.1-.8.15V0h-4.65zm51.85-3.35q1.65 0 2.92-.08 1.28-.07 2.13-.27v-7.75q-.5-.25-1.63-.43-1.12-.17-2.72-.17-1.05 0-2.23.15-1.17.15-2.15.62-.97.48-1.62 1.3-.65.83-.65 2.18 0 2.5 1.6 3.47 1.6.98 4.35.98zm-.4-23.3q2.8 0 4.72.72 1.93.73 3.1 2.05 1.18 1.33 1.68 3.15.5 1.83.5 4.03V-.45q-.6.1-1.68.27-1.07.18-2.42.33-1.35.15-2.93.28-1.57.12-3.12.12-2.2 0-4.05-.45-1.85-.45-3.2-1.43-1.35-.97-2.1-2.57-.75-1.6-.75-3.85 0-2.15.87-3.7.88-1.55 2.38-2.5t3.5-1.4q2-.45 4.2-.45.7 0 1.45.07.75.08 1.42.2.68.13 1.18.23.5.1.7.15v-1.3q0-1.15-.25-2.28-.25-1.12-.9-2-.65-.87-1.78-1.4-1.12-.52-2.92-.52-2.3 0-4.03.32-1.72.33-2.57.68l-.55-3.85q.9-.4 3-.78 2.1-.37 4.55-.37zm35.75 13.7q0-4.55-2.25-7t-6-2.45q-2.11 0-3.28.15-1.18.15-1.87.35v16.4q.85.7 2.44 1.35 1.6.65 3.5.65 2 0 3.43-.73 1.42-.72 2.32-2 .91-1.27 1.31-2.99.4-1.73.4-3.73zm4.85 0q0 2.95-.78 5.45t-2.28 4.3q-1.5 1.8-3.67 2.8-2.17 1-4.98 1-2.25 0-3.97-.6-1.72-.6-2.57-1.15v10.4h-4.65V-25.2q1.65-.4 4.12-.88 2.47-.47 5.72-.47 3 0 5.41.95 2.4.95 4.09 2.7 1.71 1.75 2.63 4.27.93 2.53.93 5.68z"
                          className="wordmark-text-0"
                          data-fill-palette-color="primary"
                          opacity="1"
                        ></path>
                      </svg>
                    </svg>
                  </svg>
                </g>
              </svg>
            </svg>
          </svg>
        </svg>
      </svg>
    </svg>
  );
}

export default LifemapLogo;
